import { render } from "./size-guide-table.vue?vue&type=template&id=354c7fc2"
import script from "./size-guide-table.vue?vue&type=script&lang=js"
export * from "./size-guide-table.vue?vue&type=script&lang=js"

import "./size-guide-table.vue?vue&type=style&index=0&id=354c7fc2&lang=scss"

import exportComponent from "/Users/mcoombes/Dev/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__